/**
 * Tarih Formatlayıcı Yardımcı Fonksiyonlar
 * Tüm tarihleri gün/ay/yıl (GG.AA.YYYY) formatına dönüştürür.
 */

export const formatDate = (dateInput?: string | Date | number | null): string => {
  if (!dateInput) return '';

  if (typeof dateInput === 'string') {
    const trimmed = dateInput.trim();
    if (!trimmed) return '';

    // Eğer zaten GG.AA.YYYY veya GG/AA/YYYY formatındaysa olduğu gibi koru
    if (/^\d{2}[./]\d{2}[./]\d{4}/.test(trimmed)) {
      return trimmed;
    }

    // YYYY-MM-DD veya YYYY-MM-DDTHH:mm:ss formatını timezone kayması olmadan parçala
    const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      const [, y, m, d] = isoMatch;
      return `${d}.${m}.${y}`;
    }

    // Metin içeren ifadeleri (örn: "Ekim 2026") olduğu gibi koru
    if (/[a-zA-ZğüşıöçĞÜŞİÖÇ]/.test(trimmed)) {
      return trimmed;
    }
  }

  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return String(dateInput);

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
};

/**
 * Bir ziyaretin gün ve saatinin gelip gelmediğini kontrol eder.
 * Eğer ziyaret günü/saati henüz gelmemişse (gelecekte ise) 'YAPILDI' olarak işaretlenemez.
 */
export const canMarkVisitAsCompleted = (
  visitDateStr: string | null | undefined,
  startTimeStr?: string | null
): { allowed: boolean; reason?: string } => {
  if (!visitDateStr) return { allowed: true };

  const now = new Date();
  const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

  // 1. Ziyaret günü gelecekte bir tarih ise kesinlikle izin verme
  if (visitDateStr > todayStr) {
    return {
      allowed: false,
      reason: `Ziyaret tarihi (${formatDate(visitDateStr)}) henüz gelmemiştir. Gelecek tarihteki bir ziyaret "YAPILDI" olarak işaretlenemez.`
    };
  }

  // 2. Eğer ziyaret tarihi bugün ise saat kontrolü yap
  if (visitDateStr === todayStr && startTimeStr) {
    const timeMatch = startTimeStr.trim().match(/^(\d{1,2}):(\d{2})/);
    if (timeMatch) {
      const visitHour = parseInt(timeMatch[1], 10);
      const visitMinute = parseInt(timeMatch[2], 10);
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      if (visitHour > currentHour || (visitHour === currentHour && visitMinute > currentMinute)) {
        return {
          allowed: false,
          reason: `Ziyaret saati (${startTimeStr}) henüz gelmemiştir. Ziyaret başlama saati gelmeden "YAPILDI" olarak işaretlenemez.`
        };
      }
    }
  }

  return { allowed: true };
};

export const formatDateDMY = formatDate;
export default formatDate;
